// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1h6xK","label":"Labeled_label__3vIqv","divider":"Labeled_divider__NYF8u"};